import { g as u } from "./index-DUTDaDpU.mjs";
let d;
const p = async () => typeof window > "u" ? !1 : (d === void 0 && (d = new Promise((e) => {
  const n = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", t = new XMLHttpRequest();
  t.timeout = 1e3, t.addEventListener("readystatechange", function() {
    t.readyState === XMLHttpRequest.DONE && e(t.status === 0 || t.responseURL !== n);
  }), t.open("HEAD", n, !0), t.send(null);
})), d);
function h(e, n) {
  return (/* @__PURE__ */ new Set(["0", "1"])).has(n) ? e : `${e}-${n}`;
}
let r;
async function v(e) {
  return r !== void 0 || (r = await p() ? Promise.resolve(void 0) : new Promise((t) => {
    setTimeout(() => {
      t(void 0);
    }, 5e3), u("get", e, "client_id", (o) => t(o));
  })), r;
}
async function f(e) {
  try {
    const n = {
      cid: e.clientId,
      ea: e.event.action,
      ec: e.event.category,
      el: e.event.label,
      t: "event",
      tid: e.trackingId,
      v: 1
    };
    location.hostname && (n.dh = location.hostname), location.origin && (n.dl = location.origin);
    const t = Object.entries(n).map(([s, a]) => `${s}=${encodeURIComponent(a)}`).join("&"), o = await fetch("https://www.google-analytics.com/collect", {
      body: t,
      method: "POST"
    });
    if (!o.ok) {
      const s = await o.text();
      throw new Error(`Bad response from Google Analytics: ${o.status}
${s}`);
    }
  } catch (n) {
    console.error(new Error("Failed to send GA event", {
      cause: n
    }));
  }
}
async function y(e) {
  var n, t, o;
  const {
    event: s
  } = e, a = `${(n = s.category) !== null && n !== void 0 ? n : ""}_${(t = s.subcategory) !== null && t !== void 0 ? t : ""}_${(o = s.action) !== null && o !== void 0 ? o : ""}`;
  try {
    const i = {
      client_id: e.clientId,
      events: [{
        name: a,
        params: {
          ...e.event.customized_parameters,
          ...location.hostname && {
            hostname: location.hostname
          },
          ...location.origin && {
            page_location: location.origin
          }
        }
      }]
    }, m = JSON.stringify(i), l = new URL("https://www.google-analytics.com/mp/collect");
    l.search = new URLSearchParams({
      api_secret: e.measurementApiKey,
      measurement_id: e.measurementId
    }).toString();
    const c = await fetch(l, {
      body: m,
      method: "POST"
    });
    if (!c.ok) {
      const g = await c.text();
      throw new Error(`Bad response from Google Analytics: ${c.status}
${g}`);
    }
  } catch (i) {
    console.error(new Error("Failed to send GA4 event", {
      cause: i
    }));
  }
}
export {
  y as a,
  h as c,
  p as d,
  v as g,
  f as s
};
//# sourceMappingURL=index-DLl81wX6.mjs.map
